import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker';
import logout from './../../Global/logout';

export default async function DeleteClientType(   
   countryUuid = "",
   typeUuid = ""
) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    let query = "/" + typeUuid + "?countryUuid=" + countryUuid
    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/client/type' + query, {
            method: 'delete',
            headers: { 'Authorization' : unHashedJwt}           
        }).then(res => res)
        .catch(error => error.response.data)
    );
}